import * as React from 'react';

import LegalContract56 from './LegalContract56';

export const legalContract56 = () => <LegalContract56 />;

export default {
    title: 'Illustration|LegalContract56',
    component: LegalContract56,
    parameters: {
        notes: "`import LegalContract56 from 'box-ui-elements/es/illustration/LegalContract56';`",
    },
};
